/**
 *
 * @param {string} name
 * @returns
 */

import key from './key'

const url = `app/${key}`

export const LOAD_EVENT_DATE_RECORDS = `${url}/LOAD_EVENT_DATE_RECORDS`
export const LOAD_EVENT_DATE_RECORDS_SUCCESS = `${url}/LOAD_EVENT_DATE_RECORDS_SUCCESS`
export const LOAD_EVENT_DATE_RECORDS_ERROR = `${url}/LOAD_EVENT_DATE_RECORDS_ERROR`
export const LOAD_RECORD_EVENT_DETAILS = `${url}/LOAD_RECORD_EVENT_DETAILS`
export const LOAD_RECORD_EVENT_DETAILS_SUCCESS = `${url}/LOAD_RECORD_EVENT_DETAILS_SUCCESS`
export const LOAD_RECORD_EVENT_DETAILS_ERROR = `${url}/LOAD_RECORD_EVENT_DETAILS _ERROR`
export const LOAD_RECORD_EVENT_DETAILS_META_DATA = `${url}/LOAD_RECORD_EVENT_DETAILS_META_DATA`
export const LOAD_RECORD_EVENT_DETAILS_META_DATA_SUCCESS = `${url}/LOAD_RECORD_EVENT_DETAILS_META_DATA_SUCCESS`
export const LOAD_RECORD_EVENT_DETAILS_META_DATA_ERROR = `${url}/LOAD_RECORD_EVENT_DETAILS_META_DATA_ERROR`
export const CREATE_EVENT_RECORD = `${url}/CREATE_EVENT_RECORD`
export const CREATE_EVENT_RECORD_SUCCESS = `${url}/CREATE_EVENT_RECORD_SUCCESS`
export const CREATE_EVENT_RECORD_ERROR = `${url}/CREATE_EVENT_RECORD_ERROR`
export const UPDATE_EVENT_RECORD = `${url}/UPDATE_EVENT_RECORD`
export const UPDATE_EVENT_RECORD_SUCCESS = `${url}/UPDATE_EVENT_RECORD_SUCCESS`
export const UPDATE_EVENT_RECORD_ERROR = `${url}/UPDATE_EVENT_RECORD_ERROR`
export const DELETE_EVENT_RECORD = `${url}/DELETE_EVENT_RECORD`
export const DELETE_EVENT_RECORD_SUCCESS = `${url}/DELETE_EVENT_RECORD_SUCCESS`
export const DELETE_EVENT_RECORD_ERROR = `${url}/DELETE_EVENT_RECORD_ERROR`
export const LOAD_RECORDS_META_DATA = `${url}/LOAD_RECORDS_META_DATA`
export const LOAD_RECORDS_META_DATA_SUCCESS = `${url}/LOAD_RECORDS_META_DATA_SUCCESS`
export const LOAD_RECORDS_META_DATA_ERROR = `${url}/LOAD_RECORDS_META_DATA_ERROR`
export const LOAD_RECORDS_VALID_CACHE = `${url}/LOAD_RECORDS_VALID_CACHE`
export const UPDATE_EVENT_STATUS = `${url}/UPDATE_EVENT_STATUS`
export const UPDATE_EVENT_STATUS_SUCCESS = `${url}/UPDATE_EVENT_STATUS_SUCCESS`
export const UPDATE_EVENT_STATUS_ERROR = `${url}/UPDATE_EVENT_STATUS_ERROR`

export const LOAD_OFFER_LIST = `${url}/LOAD_OFFER_LIST`
export const LOAD_OFFER_LIST_SUCCESS = `${url}/LOAD_OFFER_LIST_SUCCESS`
export const LOAD_OFFER_LIST_ERROR = `${url}/LOAD_OFFER_LIST _ERROR`

export const LOAD_VENUE_LIST = `${url}/LOAD_VENUE_LIST`
export const LOAD_VENUE_LIST_SUCCESS = `${url}/LOAD_VENUE_LIST_SUCCESS`
export const LOAD_VENUE_LIST_ERROR = `${url}/LOAD_VENUE_LIST _ERROR`


export const ADD_VENUE_LIST = `${url}/ADD_VENUE_LIST`
export const ADD_VENUE_LIST_SUCCESS = `${url}/ADD_VENUE_LIST_SUCCESS`
export const ADD_VENUE_LIST_ERROR = `${url}/ADD_VENUE_LIST_ERROR`

export const LOAD_CITY_VENUE = `${url}/LOAD_CITY_VENUE`
export const LOAD_CITY_VENUE_SUCCESS = `${url}/LOAD_CITY_VENUE_SUCCESS`
export const LOAD_CITY_VENUE_ERROR = `${url}/LOAD_CITY_VENUE _ERROR`
export const UPDATE_VENUE_LIST = `${url}/UPDATE_VENUE_LIST`
export const UPDATE_VENUE_LIST_SUCCESS = `${url}/UPDATE_VENUE_LIST_SUCCESS`
export const UPDATE_VENUE_LIST_ERROR = `${url}/UPDATE_VENUE_LIST_ERROR`

export const CREATE_OFFER_LIST = `${url}/CREATE_OFFER_LIST`
export const CREATE_OFFER_LIST_SUCCESS = `${url}/CREATE_OFFER_LIST_SUCCESS`
export const CREATE_OFFER_LIST_ERROR = `${url}/CREATE_OFFER_LIST_ERROR`


export const LOAD_VENUE_LOCATION_LIST = `${url}/LOAD_VENUE_LOCATION_LIST`
export const LOAD_VENUE_LOCATION_LIST_SUCCESS = `${url}/LOAD_VENUE_LOCATION_LIST_SUCCESS`
export const LOAD_VENUE_LOCATION_LIST_ERROR = `${url}/LOAD_VENUE_LOCATION_LIST _ERROR`


export const ADD_VENUE_LOCATION_LIST = `${url}/ADD_VENUE_LOCATION_LIST`
export const ADD_VENUE_LOCATION_LIST_SUCCESS = `${url}/ADD_VENUE_LOCATION_LIST_SUCCESS`
export const ADD_VENUE_LOCATION_LIST_ERROR = `${url}/ADD_VENUE_LOCATION_LIST_ERROR`
export const UPDATE_VENUE_LOCATION_LIST = `${url}/UPDATE_VENUE_LOCATION_LIST`
export const UPDATE_VENUE_LOCATION_LIST_SUCCESS = `${url}/UPDATE_VENUE_LOCATION_LIST_SUCCESS`
export const UPDATE_VENUE_LOCATION_LIST_ERROR = `${url}/UPDATE_VENUE_LOCATION_LIST_ERROR`

const constants = {
  LOAD_EVENT_DATE_RECORDS,
  LOAD_EVENT_DATE_RECORDS_ERROR,
  LOAD_EVENT_DATE_RECORDS_SUCCESS,
  CREATE_EVENT_RECORD,
  CREATE_EVENT_RECORD_SUCCESS,
  CREATE_EVENT_RECORD_ERROR,
  UPDATE_EVENT_RECORD,
  UPDATE_EVENT_RECORD_SUCCESS,
  UPDATE_EVENT_RECORD_ERROR,
  DELETE_EVENT_RECORD,
  DELETE_EVENT_RECORD_SUCCESS,
  DELETE_EVENT_RECORD_ERROR,
  UPDATE_EVENT_STATUS,
  UPDATE_EVENT_STATUS_SUCCESS,
  UPDATE_EVENT_STATUS_ERROR,
  LOAD_RECORDS_VALID_CACHE,
  LOAD_RECORDS_META_DATA,
  LOAD_RECORDS_META_DATA_SUCCESS,
  LOAD_RECORDS_META_DATA_ERROR,
  LOAD_RECORD_EVENT_DETAILS,
  LOAD_RECORD_EVENT_DETAILS_SUCCESS,
  LOAD_RECORD_EVENT_DETAILS_ERROR,

  //Offer
  CREATE_OFFER_LIST,
  CREATE_OFFER_LIST_SUCCESS,
  CREATE_OFFER_LIST_ERROR,

  ADD_VENUE_LIST,
  ADD_VENUE_LIST_SUCCESS,
  ADD_VENUE_LIST_ERROR,

  UPDATE_VENUE_LIST,
  UPDATE_VENUE_LIST_SUCCESS,
  UPDATE_VENUE_LIST_ERROR,

  LOAD_OFFER_LIST,
  LOAD_OFFER_LIST_SUCCESS,
  LOAD_OFFER_LIST_ERROR,

  //Venue
 LOAD_VENUE_LIST,
 LOAD_VENUE_LIST_SUCCESS,
 LOAD_VENUE_LIST_ERROR,
  //Venue NAme
LOAD_CITY_VENUE,
LOAD_CITY_VENUE_SUCCESS,
LOAD_CITY_VENUE_ERROR,

//Venue locations
LOAD_VENUE_LOCATION_LIST,
LOAD_VENUE_LOCATION_LIST_SUCCESS,
LOAD_VENUE_LOCATION_LIST_ERROR,

ADD_VENUE_LOCATION_LIST,
ADD_VENUE_LOCATION_LIST_SUCCESS,
ADD_VENUE_LOCATION_LIST_ERROR,

UPDATE_VENUE_LOCATION_LIST,
UPDATE_VENUE_LOCATION_LIST_SUCCESS,
UPDATE_VENUE_LOCATION_LIST_ERROR,
}

export default constants
